import { useEffect, useMemo, useRef } from "react";
import type { NextRouter } from "next/router";
import { ToasterService } from "@Front/Components/DesignSystem/Toaster";
import {
	getLoginErrorMessage,
	LOGIN_ERROR_CODES,
} from "@Front/Components/Layouts/Login/constants/loginErrorCodes";
import { useSiteTextContent } from "@Front/Stores/SiteTextsContext";

function resolveLoginErrorMessage(
	errorParam: string | string[] | undefined,
	ssoSessionExpiredText: string,
): string | null {
	const code = Array.isArray(errorParam) ? errorParam[0] : errorParam;
	if (code === LOGIN_ERROR_CODES.SSO_SESSION_EXPIRED) {
		return ssoSessionExpiredText;
	}
	return getLoginErrorMessage(errorParam);
}

export function useLoginErrorParamToaster(router: NextRouter, loginErrorTitle: string): string | null {
	const errorParam = router.query["error"];
	const ssoSessionExpiredText = useSiteTextContent("login.sso.sessionExpired");
	const loginErrorMessage = useMemo(
		() => resolveLoginErrorMessage(errorParam, ssoSessionExpiredText),
		[errorParam, ssoSessionExpiredText],
	);
	const lastToasterErrorRef = useRef<string | null>(null);

	useEffect(() => {
		if (!loginErrorMessage) {
			lastToasterErrorRef.current = null;
			return;
		}
		if (lastToasterErrorRef.current === loginErrorMessage) {
			return;
		}
		lastToasterErrorRef.current = loginErrorMessage;
		ToasterService.getInstance().error({
			title: loginErrorTitle,
			description: loginErrorMessage,
		});
	}, [loginErrorMessage, loginErrorTitle]);

	return loginErrorMessage;
}
